export default "__VITE_ASSET__DclSEITz__"